/**
 * Devido ao uso inicial do setInterval() para solicitar o Loads a cada minuto,
 * e sabendo que isso pode destinar a chamar o retorno da requisição várias vezes.
 * Este serviço será utilizado para controlar as requisições efetuadas para o backend, fazendo com que haja uma unica por vez.
 */
import { getters } from "@/observables";

const searchPromises = [] as Array<any>;

function makeSearchPromise() {
  return {
    path: "" as string,
    promise: null as any,
    isPending: false as boolean
  };
}

export default (path: string, force = false, config = {}) => {
  const axiosInstance = getters.getAxiosSgpInstace();
  // find promise
  const oldPromise = searchPromises.find(i => i.isPending && i.path === path);
  if (oldPromise && !force) {
    return oldPromise.promise;
  }

  const newPromise = makeSearchPromise();
  newPromise.promise = new Promise((resolve, reject) => {
    newPromise.isPending = true;
    newPromise.path = path;
    axiosInstance
      .get(path, config)
      .then(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      )
      .finally(() => {
        const index = searchPromises.indexOf(newPromise);
        searchPromises.splice(index, 1);
      });
    searchPromises.push(newPromise);
  });
  return newPromise.promise;
};
